import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useClosuresUserIdParam() {
  const { userDetails, isSuccess } = useGetMe();
  const currentUserId = userDetails?.userEntity?.id ?? "";
  const [searchParams, setSearchParams] = useSearchParams();
  const userIdParam = searchParams.get("userId") ?? "";

  const setUserIdParam = (userId: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("userId", userId);
      return next;
    });
  };

  useEffect(() => {
    if (!isSuccess || !currentUserId || userIdParam) {
      return;
    }

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("userId", currentUserId);
        return next;
      },
      { replace: true }
    );
  }, [isSuccess, currentUserId, userIdParam, setSearchParams]);

  return {
    userDetails,
    isSuccess,
    currentUserId,
    userIdParam,
    setUserIdParam,
    isSuperUser: Boolean(
      userDetails?.userEntity?.permissions?.includes("super")
    ),
  };
}
